import { render, staticRenderFns } from "./dashboard-member-zone.vue?vue&type=template&id=3b932648&scoped=true&"
import script from "./dashboard-member-zone.vue?vue&type=script&lang=js&"
export * from "./dashboard-member-zone.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-member-zone.vue?vue&type=style&index=0&id=3b932648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b932648",
  null
  
)

export default component.exports